export default __webpack_public_path__ + "static/media/image3.b8266d2a.jpg";